import 'jquery-validation';

export default {
  init: function () {
    var loginForm = $("#login_form");

    if (loginForm) {
      var submitButton = $('#wp-submit');

      submitButton.click(function (e) {
        e.preventDefault();

        const showLoader = () => {
          submitButton.append('<span class="register-btn-loader"> <i class="fas fa-circle-notch fa-spin fa-fw"></i></span>');
          submitButton.attr("disabled", true);
        }

        const hideLoader = () => {
          submitButton.find('.register-btn-loader').remove();
          submitButton.attr("disabled", false);
        }

        // Show loader on button click
        showLoader();

        // Show loader for second as the validation is too fast.
        setTimeout(() => {
          var valid = loginForm.valid();

          if (valid) {
            // Add hidden input that is added via JS so we know that JS fired and that is the source of the form submit
            loginForm.append('<input type="hidden" name="login_submitted_via_js" value="1" />');

            const showCaptchaErrorMessage = () => {
              loginForm.prepend('<h3 class="mb-5 text-center">Server validation error. <br />Please try again later.</h3>');
            }

            const generateCaptchaTokenAndSubmit = () => {
              // eslint-disable-next-line no-undef
              grecaptcha.ready(() => {
                try {
                    // eslint-disable-next-line no-undef
                    grecaptcha.execute(mbLoginCaptchaData.siteKey, {action: 'login' })
                      .then(function(token) {
                        document.querySelector('#recaptcha').value = token;
                      })
                      .then(function () {
                        // Wait 1.5s just in case to add the token to the #recaptcha input
                        setTimeout(function () {
                          loginForm.submit();
                        }, 1000);
                      })
                      // eslint-disable-next-line no-unused-vars
                      .catch((error) => {
                        showCaptchaErrorMessage();
                      });
                } catch (error) {
                  // Exception outside the promise
                  showCaptchaErrorMessage();
                }
              });
            };

            generateCaptchaTokenAndSubmit();
          } else {
            hideLoader();
          }
        }, 1000);
      });

      loginForm.validate({
        onsubmit: false,
        errorElement: "span",
      });
    }

    /**
     * Toggle password type to view password
     */
    const inputPassword = $('.mb-login__password input');
    $('.mb-login__eye').click(function () {
      if (inputPassword.attr('type') === 'text') {
        inputPassword.attr('type', 'password');
      } else {
        inputPassword.attr('type', 'text');
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/login.js